import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin } from "lucide-react";

export default function Footer() {
    return (
        <footer className="bg-[#0E1A4A] text-white mt-20" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="bg-white rounded-2xl px-5 py-4 inline-flex">
                            <Logo height={56} />
                        </div>
                        <h3 className="mt-8 text-3xl sm:text-4xl font-semibold tracking-tight leading-tight max-w-md">
                            Make your home smarter.<br />
                            <span className="text-[#1BB6F0]">Without replacing it.</span>
                        </h3>
                        <Link
                            to="/contact"
                            className="mt-6 inline-flex items-center gap-2 bg-[#1BB6F0] hover:bg-[#1E90FF] text-white rounded-full px-6 py-3 font-medium transition-colors"
                            data-testid="footer-cta"
                        >
                            Get Free Consultation
                        </Link>
                    </div>

                    <div className="md:col-span-2">
                        <div className="text-xs uppercase tracking-[0.2em] text-[#1BB6F0] font-semibold mb-4">Explore</div>
                        <ul className="space-y-3 text-sm text-white/80">
                            <li><Link to="/experience-smart-living" className="hover:text-white">Experience Smart Living</Link></li>
                            <li><Link to="/calculator" className="hover:text-white">Cost Calculator</Link></li>
                            <li><Link to="/contact" className="hover:text-white">Book Consultation</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="text-xs uppercase tracking-[0.2em] text-[#1BB6F0] font-semibold mb-4">Company</div>
                        <ul className="space-y-3 text-sm text-white/80">
                            <li><Link to="/about" className="hover:text-white" data-testid="footer-about">About</Link></li>
                            <li><Link to="/warranty" className="hover:text-white" data-testid="footer-warranty">Warranty</Link></li>
                            <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-xs uppercase tracking-[0.2em] text-[#1BB6F0] font-semibold mb-4">Reach us</div>
                        <ul className="space-y-3 text-sm text-white/80">
                            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#1BB6F0]" /> +91 81448 14162</li>
                            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#1BB6F0]" /> hello@gosmartnest.com</li>
                            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-[#1BB6F0] mt-0.5" /> Kolkata · Gurugram · Bhubaneswar · Agartala</li>
                        </ul>
                        <div className="flex items-center gap-3 mt-5">
                            <a href="#" aria-label="Instagram" className="p-2 rounded-full bg-white/10 hover:bg-white/20"><Instagram className="w-4 h-4" /></a>
                            <a href="#" aria-label="Facebook" className="p-2 rounded-full bg-white/10 hover:bg-white/20"><Facebook className="w-4 h-4" /></a>
                            <a href="#" aria-label="LinkedIn" className="p-2 rounded-full bg-white/10 hover:bg-white/20"><Linkedin className="w-4 h-4" /></a>
                        </div>
                    </div>
                </div>

                <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/60">
                    <div>© {new Date().getFullYear()} GoSmartNest Automation. All rights reserved.</div>
                    <div className="flex items-center gap-5">
                        <a href="#" className="hover:text-white">Privacy</a>
                        <a href="#" className="hover:text-white">Terms</a>
                        <a href="#" className="hover:text-white">Warranty Policy</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
